import './css/app.css'

/**
 * Entrée client volontairement minuscule : la feuille de style (extraite au
 * build) et l'ordonnancement du démarrage, rien d'autre.
 *
 * Tout le poids du client — React, Inertia, framer-motion, les pages — vit
 * dans boot.tsx, chargé en import() dynamique APRÈS la première frame peinte.
 * Un script defer s'exécute avant la toute première occasion de peindre : si
 * ce module importait React statiquement, téléchargement et évaluation du
 * bundle repousseraient le premier paint du HTML SSR (~2 s sur mobile simulé,
 * mesuré au 31/07/2026). L'ordonnancement garantit un démarrage APRÈS ce
 * paint : le callback rAF s'exécute dans le cycle de la frame en cours, juste
 * avant sa composition, et la tâche setTimeout qu'il pose ne passe qu'une fois
 * la frame — le HTML SSR complet — affichée.
 *
 * Avant l'hydratation, la page est du HTML ordinaire : les liens sont de vrais
 * <a>, un clic très précoce déclenche une navigation classique au lieu d'une
 * visite Inertia. C'est le comportement voulu : contenu d'abord, JS ensuite.
 *
 * Filet de sécurité : un onglet ouvert en arrière-plan ne compose aucune
 * frame, donc son rAF ne se déclenche qu'au premier passage au premier plan.
 * Sans le timer, un tel onglet resterait du HTML mort (pas d'hydratation, pas
 * de consentement, pas d'analytics) tant qu'il n'est pas affiché.
 */
let bootStarted = false
const boot = (): void => {
  if (bootStarted) return
  bootStarted = true
  import('./boot')
}

requestAnimationFrame(() => {
  setTimeout(boot, 0)
})
setTimeout(boot, 2500)
